import axios from 'axios'
import { extractOcrTextFromResponse, parsePayFromOcrText,parseReceiptPartiesFromOcrText } from '../util/ocrVoucherParse'



const http = axios.create({
  baseURL: 'http://8.153.19.157:1224/api/ocr',
  timeout: 30000
})

/** 打款凭证 OCR：与本地 Umi-OCR 等 HTTP 接口一致 */
const OCR_HTTP_OPTIONS = {
  'ocr.language': 'models/config_chinese.txt',
  'ocr.cls': true,
  'ocr.limit_side_len': 999999,
  'tbpu.parser': 'multi_para',
  'data.format': 'text'
}

function getOcrApiUrl() {
  const base = 'http://8.153.19.157:1224/api/ocr'
  return base;
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const s = reader.result
      if (typeof s !== 'string') {
        reject(new Error('read failed'))
        return
      }
      const i = s.indexOf(',')
      resolve(i >= 0 ? s.slice(i + 1) : s)
    }
    reader.onerror = () => reject(reader.error || new Error('read failed'))
    reader.readAsDataURL(file)
  })
}

/**
 * 合并打款：同时写入 paymentmout、paymentmoutdetal
 * body: { paymentmout: {...}, paymentmoutdetal: [...] } 见 buildMergePaymentPayload
 * 响应建议: { orderid, paymentmout?, paymentmoutdetal: [{ id, orderid, payoutid, ... }] }
 */
export function createMergePayment(body) {
  return http.post('/payment/merge', body)
}

/**
 * 打款凭证图片 OCR：POST JSON { base64, options } 到 OCR 服务，再从识别文本解析账号与户名
 * @param {File|Blob} file 图片文件
 * 响应 data: { payaccount, payaccountname, payvoucherUrl? }
 * Mock：仅 VUE_APP_USE_MOCK_OCR=true；否则一律 POST 真实 OCR
 * 地址：VUE_APP_OCR_BASE 为完整 URL 时直连；否则默认 /ocr-service（dev 代理到 127.0.0.1:1224）
 */
export async function recognizePaymentVoucher(file) {
    const base64 = await fileToBase64(file)
    const res = await axios.post(
        getOcrApiUrl(),
        { base64, options: OCR_HTTP_OPTIONS },
        {
            headers: { 'Content-Type': 'application/json' },
            timeout: 120000
        }
    )
    const body = res.data
    if (body && typeof body === 'object' && body.code !== undefined && body.code !== null) {
        const n = Number(body.code)
        if (!Number.isNaN(n) && n !== 100 && n !== 0) {
            const msg = body.message || body.msg || body.data
            throw new Error(typeof msg === 'string' && msg ? msg : `OCR 错误 (${body.code})`)
        }
    }
    const text = extractOcrTextFromResponse(res)
    const parsed = parsePayFromOcrText(text)
    const receipt = parseReceiptPartiesFromOcrText(text)
    return {
        data: {
            payaccount: receipt.payerAccount || parsed.payaccount,
            payaccountname: receipt.payerName || parsed.payaccountname,
            recvaccount: receipt.payeeAccount,
            recvaccountname: receipt.payeeName,
            amount: receipt.amount,
            payvoucherUrl: '',
        },
    }
}



// WEBPACK FOOTER //
// ./src/util/payment.js